module.exports = __webpack_public_path__ + "static/media/prinny-dead.9784547a.png";